<template>
  <div>
        <section>
                <div class="">
                     <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailSupplier">
                        <template v-if="helper.checkAccess('create_supplier_invoices') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('invoice')}}</span>
                            </button>
                        </template>
                    </div>

                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailSupplier" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm" v-if="filter.key === 'total_amount'">
                                                <select v-model="filter.operator" class="form-select" style="max-width: 80px;">
                                                    <option value="gt">{{$t('operator_gt')}}</option>
                                                    <option value="lt">{{$t('operator_lt')}}</option>
                                                    <option value="eq">{{$t('operator_eq')}}</option>
                                                </select>
                                                <input type="number" v-model="filter.value" class="form-control form-control-sm" placeholder="0">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div class="input-group input-group-sm" v-else>
                                                <select v-model="filter.value" class="form-select form-select-sm">
                                                    <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                        {{$t(option.label)}}
                                                    </option>
                                                </select>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        
                        <!-- Desktop action buttons -->
                        <template v-if="helper.checkAccess('create_supplier_invoices') != -1">
                            <div class="col-md-2 d-none d-md-block">
                                <button @click="create" class="btn btn-sm btn-success w-100">
                                    <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                    <span>{{$t('invoice')}}</span>
                                </button>
                            </div>
                        </template>
                    </div>
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- Bulk Action Bar -->
                    <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
                        <div class="d-flex align-items-center">
                            <span class="fw-bold me-2">{{ selectedCount }}</span>
                            <span class="text-muted">{{$t('selected')}}</span>
                        </div>
                        <div class="d-flex gap-2">
                            <button v-if="helper.checkAccess('delete_supplier_invoices') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                                <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                            </button>
                        </div>
                    </div>

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="total" label="total" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="amount_paid" label="amount_paid" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="purchase" label="purchase" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header v-if="!hideClient" field="supplier" label="supplier" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="due_date" label="due_date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="created_by" label="created_by" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <th class="pt-4 pb-3 px-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Columns">
                                                    <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 200px; max-height: 300px; overflow-y: auto;">
                                                    <li>
                                                        <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                                    </li>
                                                    <li v-if="helper.checkAccess('create_supplier_invoices') != -1">
                                                        <a class="dropdown-item" href="#" @click="triggerScan">
                                                            {{ $t('scan_invoice') }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="invoice in invoices" :key="invoice.id" :class="{'table-active': invoice.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="invoice.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td class="py-5 px-6"><router-link :to="`/supplier-invoices/${invoice.id}`"><b>{{invoice.reference}}</b></router-link></td>
                                <td class="py-5 px-6">{{formatMoney(calculateItemPrice(invoice))}} </td>
                                <td class="py-5 px-6">{{invoice.transactions.length ? formatMoney(invoice.transactions.reduce((sum, item) => sum + item.amount, 0)) : 0}} </td>
                                <td class="py-5 px-6">
                                    <div v-if="helper.checkAccess('edit_supplier_invoices') != -1" class="dropdown">
                                        <button
                                            :id="`supplier-invoice-status-${invoice.id}`"
                                            type="button"
                                            class="badge border-0 dropdown-toggle"
                                            :class="getSupplierInvoiceStatusBadgeClass(invoice.status)"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            :disabled="isSupplierInvoiceStatusDropdownDisabled(invoice)"
                                        >
                                            <span v-if="statusUpdatingSupplierInvoiceId === invoice.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            {{ $t(invoice.status) }}
                                        </button>
                                        <ul class="dropdown-menu shadow" :aria-labelledby="`supplier-invoice-status-${invoice.id}`">
                                            <li v-for="status in getSupplierInvoiceStatusOptions()" :key="status">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between gap-3"
                                                    :class="{ active: invoice.status === status }"
                                                    @click="changeSupplierInvoiceStatus(invoice, status)"
                                                >
                                                    <span>{{ $t(status) }}</span>
                                                    <AppIcon name="bi-check-lg" v-if="invoice.status === status" class="bi bi-check-lg" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <span v-else class="badge" :class="getSupplierInvoiceStatusBadgeClass(invoice.status)">
                                        {{ $t(invoice.status) }}
                                    </span>
                                </td>
                                <td class="py-5 px-6"><router-link v-if="invoice.purchase && invoice.purchase.reference" :to="`/purchases/${invoice.purchase.id}`">{{invoice.purchase && invoice.purchase.reference ? invoice.purchase.reference : '-'}}</router-link></td>
                                <td v-if="!hideClient" class="py-5 px-6"><router-link v-if="invoice && invoice.supplier && invoice.supplier.name" :to="`/suppliers/${invoice.supplier.id}`">{{invoice && invoice.supplier && invoice.supplier.name ? invoice.supplier.name : '-'}}</router-link></td>
                                <td class="py-5 px-6">{{formatDate(invoice.date)}}</td>
                                <td class="py-5 px-6"> 
                                    <span v-if="invoice.due_date">
                                        {{ formatDate(invoice.due_date) }}
                                        <span v-if="new Date(invoice.due_date) < new Date() && invoice.status != 'paid'" class="badge bg-danger ms-2">
                                            {{$t('overdue')}}
                                        </span>
                                    </span>
                                </td>
                                <td class="py-5 px-6">
                                    {{invoice.user ? invoice.user.name : '-'}}
                                </td>
                                <td class="py-5 px-6">
                                    <!-- <button @click="viewRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('invoice')}}
                                    </button> -->
                                    <button v-if="helper.checkAccess('edit_supplier_invoices') != -1" @click="editRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button v-if="helper.checkAccess('delete_supplier_invoices') != -1" @click="deleteRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                     
                                </td>
                            </tr>
                            <tr v-if="invoices.length" style="background-color: #f8f9fa;font-weight: bold">
                                <td>{{$t('total')}}:</td>
                                <td></td>
                                <td class="py-5 px-6">{{formatMoney(invoices.reduce((acc, item) => acc + calculateItemPrice(item), 0))}} </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>   
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="count > invoices.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getInvoices" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !invoices.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-receipt" class="bi bi-receipt text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_supplier_invoices_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_supplier_invoices') }}</p>
                        <template v-if="helper.checkAccess('create_supplier_invoices') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_supplier_invoice') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !invoices.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_invoice_found')}}.</div>

                </div>
                <div class="col-sm-7">
                           {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}}
                </div>
                </div>
        </section>
    

        <!-- create Modal -->
        <add-edit-invoice-modal 
            v-if="createModalisOpen" 
            @modalClosed="createModalisOpen = false"
            modalId="create-invoice-modal-01" 
            :isModalOpen="createModalisOpen" 
            :data="invoice" 
            action="create"
            @refresh="refresh"
        ></add-edit-invoice-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-invoice-modal 
            v-if="editModalisOpen" 
            @modalClosed="editModalisOpen = false" 
            modalId="edit-invoice-modal-01" 
            :isModalOpen="editModalisOpen"  
            :data="invoice" 
            action="update" 
            @refresh="refresh"
        ></add-edit-invoice-modal>
        <!-- Edit modal -->

        <!-- quote modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-invoice-modal-01" 
            :isModalOpen="invoiceModalisOpen"  
            :data="invoice" 
            type="supplier-invoice">
        </invoice-template-modal>
        <!-- quote modal -->
        
        <!-- create Modal -->
        <add-edit-credit-invoice-modal 
            v-if="createCreditInvoiceModalState" 
            @modalClosed="createCreditInvoiceModalState = false"
            modalId="create-credit-invoice-modal-01" 
            :isModalOpen="createCreditInvoiceModalState" 
            :data="invoice" 
            action="transfer"
        ></add-edit-credit-invoice-modal>
        <!-- create modal -->

        <!-- Scan Invoice Modal -->
        <scan-invoice-modal
            v-if="scanModalIsOpen"
            :isOpen="scanModalIsOpen"
            @close="scanModalIsOpen = false"
            @scan-success="handleScanSuccess"
        ></scan-invoice-modal>
        <!-- Scan Invoice Modal -->


  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
// import VueJsonToCsv from 'vue-json-to-csv'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import AddEditInvoiceModal from '../components/supplierInvoice/AddEditInvoiceModal';
import AddEditCreditInvoiceModal from '../components/creditInvoice/AddEditInvoiceModal';

import InvoiceTemplateModal from '../components/invoiceLayout/InvoiceTemplateModal';
import ScanInvoiceModal from '../components/supplierInvoice/ScanInvoiceModal';
import sortableList from '../mixins/sortableList';

export default {
  name: 'InvoiceComponent',
  persistedFilterState: {
    key: 'supplier-invoices',
    fields: ['activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
    routeQueryFields: ['status', 'start', 'end'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    AddEditInvoiceModal,
    AddEditCreditInvoiceModal,
    InvoiceTemplateModal,
    ScanInvoiceModal
  },
   props : [
    'supplier_id',
    'purchase_id',
    'purchase',
    'user_id',
    'inventory_id',
    'product_id',
    'keyword',
    'isDetailSupplier',
    'products',
    'supplier',
    'showFilters'
    ],
  data(){
    return {
        invoices : [],
        count : 0,
        page : 1,
        deliveries : [],
        invoice : {
            id : null,
            reference : `INVOICE-00`,
            date : '',
            notes : '',
            products : [], 
            supplier_id : null,
            supplier : {},
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
           { 
                key: 'status', 
                options: [
                    { value: 'all', label: 'all' },
                    { value: 'draft', label: 'draft' },
                    { value: 'pending', label: 'pending' },
                    { value: 'paid', label: 'paid' },
                    { value: 'partially_paid', label: 'partially_paid' },
                    { value: 'canceled', label: 'canceled' }
                ] 
            },
            { 
                key: 'payment_method', 
                options: [] 
            },
            {
                key: 'total_amount',
                options: [] // Special case, handled manually
            }
        ],
        totalHtPrice : 0,
        purchasePrice : 0,
        loading : false,
        statusUpdatingSupplierInvoiceId: null,
        per_page : 25,
        pagination : [],
        hideClient : false,
        createModal : null,
        editModal : null,
        createCreditInvoiceModalState : false,
        invoiceModalisOpen : false,
        createModalisOpen :false,
        editModalisOpen :false,
        createClientState : false,
        isSelectedItem: false,
        scanning: false,
        scanModalIsOpen: false
    }
  },
  async mounted(){
    // Apply query params from dashboard navigation (status filter + date range)
    const query = this.$route.query;
    let shouldFetch = true;

    if (query.status) {
        const statusValue = query.status;
        if (['paid', 'pending', 'partially_paid', 'canceled', 'draft', 'overdue'].includes(statusValue)) {
            this.activeFilters.push({ key: 'status', value: statusValue });
        }
    }
    if (query.start && query.end) {
        this.dateRangeOption = 'custom';
        this.start = query.start;
        this.end = query.end;
        // Setting range will trigger the watcher which calls getInvoices()
        this.range = [new Date(query.start), new Date(query.end)];
        shouldFetch = false;
    } else {
        // Initialize default date range
        // this.handleDateRangeChange()
        if (this.range && this.range.length === 2 && this.range[0] && this.range[1]) {
            shouldFetch = false;
        }
    }

    if (shouldFetch) {
        this.getInvoices()
    }

    // Translate filters (Not really needed to re-assign if we use $t in template, but keeping payment method fetch)
    this.fetchPaymentMethods()

    // Check for create param and scanned data from AI
    if(this.$route.query.create === 'true' && this.$route.query.scanned_data) {
        this.loading = true;
        try {
            const scannedData = JSON.parse(this.$route.query.scanned_data);
            const processedData = await this.processAndCreateEntities(scannedData);
            this.openCreateModalWithData(processedData);
            
            // Clean up query params
            const query = Object.assign({}, this.$route.query);
            delete query.create;
            delete query.scanned_data;
            this.$router.replace({ query });
        } catch(e) {
            alert(e)
        } finally {
            this.loading = false;
        }
    }
  },
  watch : {
     createModalisOpen(){
        this.getInvoices()
    },
    range(){

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getInvoices()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getInvoices()
        }else{
            this.invoices = []
        }

    },
    per_page(){
        this.getInvoices(this.page)
    },
    activeFilters: { // Watch activeFilters array deeply
        handler() {
             // this.getInvoices() // Optional immediate update
        },
        deep: true
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/supplier-invoices?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.invoices = response.data.data
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getInvoices()
    },
   
  },    
  methods : {
    triggerScan() {
        this.scanModalIsOpen = true;
    },
    async handleScanSuccess(data) {
        this.loading = true;
        try {
            const processedData = await this.processAndCreateEntities(data);
            this.openCreateModalWithData(processedData);
        } catch (e) {
            helper.handleError(e);
        } finally {
            this.loading = false;
        }
    },
    processAndCreateEntities: async function(data) {
        // Supplier is intentionally not created or attached from scanned invoices.

        // Products Auto-Creation
        if (data.products && Array.isArray(data.products)) {
            const processedProducts = [];
            for (const p of data.products) {
                const label = p.label || p.name;
                if (!label) continue;

                try {
                    const response = await helper.customGet(`${process.env.VUE_APP_API}/products?keyword=${encodeURIComponent(label)}`);
                    if (response.data && response.data.data && response.data.data.length > 0) {
                        // Found existing
                        const existing = response.data.data[0];
                        p.id = existing.id;
                        p.vat = existing.vat;
                        const scannedPrice = this.parsePrice(p.price);
                        p.price = scannedPrice > 0 ? scannedPrice : existing.price;
                    } else {
                        // Create Product
                        const newProduct = {
                            label: label,
                            price: this.parsePrice(p.price),
                            purchase_price: 0,
                            vat: 0,
                            quantity: p.quantity || 0,
                            notes: 'Auto-created from scan invoice',
                            has_variants: false,
                            variants: []
                        };
                        const createResp = await helper.customPost(`${process.env.VUE_APP_API}/products`, newProduct);
                        const created = createResp.data.product || createResp.data;
                        p.id = created.id;
                        p.vat = created.vat;
                    }
                } catch (e) {
                    alert("Error processing product", label, e);
                }
                processedProducts.push(p);
            }
            data.products = processedProducts;
        }
        return data;
    },
    parsePrice(priceStr) {
        if (typeof priceStr === 'number') return priceStr;
        if (!priceStr) return 0;
        // Remove everything except digits and dots
        let clean = priceStr.replace(/[^0-9.]/g, '');
        return parseFloat(clean) || 0;
    },
    async create(){
        this.clearForm()
        
        if(this.supplier){
            this.invoice.supplier = this.supplier
            this.invoice.supplier_id = this.supplier.id
        }

        if(this.purchase_id){
            this.invoice.purchase_id = this.purchase_id
        }

        if(this.products){
            for(let i = 0 ; i < this.products.length ; i++){
                this.products[i].label = this.products[i].product_label 
            }
            this.invoice.products = this.products
        }

        this.invoice.date = moment().format('YYYY-MM-DD')
        this.invoice.products.push({
            label : '',
            id : null,
            quantity : 0,
            price : 0,
            discount : 0,
            vat : this.business.vat,
            total : 0,
            sub_total : 0,
        })
        this.createModalisOpen = true;
    },
    openCreateModalWithData(data){
        this.clearForm()
        // Map scanned data to invoice object
        if(data.reference) this.invoice.reference = data.reference;
        if(data.date) this.invoice.date = data.date;
        if(data.due_date) this.invoice.due_date = data.due_date;
        if(data.supplier_name) {
            this.invoice.notes = `Scanned Supplier: ${data.supplier_name}`;
        }
        
        if(data.scannedFile) {
            this.invoice.scannedFile = data.scannedFile;
        }

        if(data.products && Array.isArray(data.products)){
            this.invoice.products = data.products.map(p => ({
                label: p.label || p.name || 'Unknown Product',
                quantity: p.quantity || 1,
                price: this.parsePrice(p.price),
                discount: 0,
                vat: this.parsePrice(p.vat) || this.business.vat,
                total: this.parsePrice(p.total),
                sub_total: this.parsePrice(p.sub_total) || (p.quantity * this.parsePrice(p.price)) || 0,
                custom_product: !p.id // Assume custom product since we don't have IDs
            }));
            this.invoice.products.push({
                label : '',
                id : null,
                quantity : 0,
                price : 0,
                discount : 0,
                vat : this.business.vat,
                total : 0,
                sub_total : 0,
            })
        } else {
             this.invoice.products.push({
                label : '',
                id : null,
                quantity : 0,
                price : 0,
                discount : 0,
                vat : this.business.vat,
                total : 0,
                sub_total : 0,
            })
        }
        
        this.invoice.isScanned = true;
        this.calculatePrices();
        this.createModalisOpen = true;
    },
    editRow(row){
        this.editModalisOpen = true;
        this.clearForm()
        this.invoice = row 
        this.invoice.supplier_id = row.supplier && row.supplier.id ? row.supplier.id : null
        this.invoice.date = moment(this.invoice.date).format('YYYY-MM-DD')
        this.calculatePrices()
    },
    viewRow(row){
        this.clearForm()
        this.invoice = row 
        this.invoiceModalisOpen = true;
    },
    async deleteRow(row){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/supplier-invoices/${row.id}`)
                    this.invoices = helper.withoutDeletedRecords(this.invoices, row.id)
                    this.count = Math.max(0, this.count - 1)
                }
            })
    },
    clearForm(){
        this.invoice = {
            id : null,
            reference : '',
            date : '',
            products : [],
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        }

    },
    async getInvoices(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            // Extract filters from array
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : 'all';

            const paymentFilter = this.activeFilters.find(f => f.key === 'payment_method');
            const payment_method = paymentFilter ? paymentFilter.value : 'all';

            const amountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build URL
            const params = new URLSearchParams();
            params.append('page', this.page.toString());
            params.append('per_page', this.per_page.toString());
            this.appendSortParams(params);
            if(status !== 'all') params.append('status', status);
            if(payment_method !== 'all') params.append('payment_method', payment_method);
            if(this.supplier_id) params.append('supplier_id', this.supplier_id);
            if(this.purchase_id) params.append('purchase_id', this.purchase_id);
            if(this.inventory_id) params.append('inventory_id', this.inventory_id);
            if(this.product_id) params.append('product_id', this.product_id);
            if(this.user_id) params.append('user_id', this.user_id);
            if(this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }
            if (amountFilter && amountFilter.value !== null && amountFilter.value !== '') {
                params.append('amount_operator', amountFilter.operator);
                params.append('amount_value', amountFilter.value);
            }
            if(this.keyword != "" && this.keyword != undefined){
                 params.append('keyword', this.keyword);
            }

            let url = `${process.env.VUE_APP_API}/supplier-invoices?${params.toString()}`;
            this.invoices = []

            const response = await helper.customGet(url)
            this.invoices = response.data.data
            for(let i = 0 ; i < this.invoices.length ; i++){
                this.$set(this.invoices[i], 'selected', false)
            }
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }
            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    calculatePrices(){
        this.$forceUpdate();
        for(let i = 0 ; i < this.invoice.products.length ; i++){
            this.invoice.products[i].total = parseFloat(this.invoice.products[i].price) * parseFloat(this.invoice.products[i].quantity)
            this.invoice.products[i].sub_total = Math.round(parseFloat(this.invoice.products[i].total))

            if(this.invoice.products[i].vat > 0){
                this.invoice.products[i].total += parseFloat((parseFloat(this.invoice.products[i].total) * parseFloat(this.invoice.products[i].vat / 100)).toFixed(2))
                this.invoice.products[i].total = Math.round(this.invoice.products[i].total)
            }
        }
        this.invoice.total = this.invoice.products && this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        this.totalHtPrice = this.invoice.products && this.invoice.products.length ? this.invoice.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0;
        this.purchasePrice = this.invoice.products && this.invoice.products.length ? this.invoice.products.map(o => o.purchase_price).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.invoice.products[index].price = ((price / this.invoice.products[index].quantity) / 1.2).toFixed(2)
           this.invoice.products[index].sub_total = parseFloat(this.invoice.products[index].price) * parseFloat(this.invoice.products[index].quantity)
        }
    },
    calculateItemPrice(invoice){
        if(invoice.status == "draft") return 0
        return invoice.products && invoice.products.length ? invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0; 
    },
    createClient(data){
        if(data.supplier){
            this.invoice.supplier_id = data.supplier.id
            this.invoice.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createClientState = data.state
        }
    },
    openCreateClientModal(){
        this.createClientState = !this.createClientState
    }, 
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.invoice.products[data.index] = {
                ...{
                    inventory_id : data.result.id,
                    product_id : data.result.product.id,
                    product_label : data.result.product.label || data.result.product.product_label,
                    id : data.result.product.id,
                    quantity : 0,
                    maxQty : data.result.quantity,
                    price : data.result.price,
                    unity : data.result.unity,
                    purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                    vat :  this.business.vat,
                    total : data.result.total ? data.result.total : 0,
                    sub_total : data.result.sub_total ? data.result.sub_total : 0,
                }
            } 
            this.invoice.products = [...this.invoice.products]
            // for(let i = 0 ; i < this.invoice.products.length ; i++){
            //     this.invoice.products[i].maxQty = this.invoice.products[i].quantity;
            // }

            this.calculatePrices()
        }
    },
    emitAutoCompleteClient(data){
        this.invoice.supplier_id = data.result.id
        this.invoice.supplier = data.result
    },
    getStatus(status){
       if(status == 'paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'partially_paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'pending'){
         return 'badge bg-primary rounded-pill small'
       }else if(status == 'refunded'){
         return 'badge bg-info rounded-pill small'
       }
    },
    getSupplierInvoiceStatusBadgeClass(status){
        return {
            'bg-info': status === 'draft',
            'bg-success': status === 'paid',
            'bg-warning': status === 'partially_paid',
            'bg-danger': status === 'canceled' || status === 'overdue',
            'bg-secondary': status === 'pending'
        }
    },
    getSupplierInvoiceStatusOptions(){
        const filter = this.availableFilters.find(filter => filter.key === 'status')
        return filter ? filter.options.filter(option => option.value !== 'all').map(option => option.value) : []
    },
    isSupplierInvoiceStatusDropdownDisabled(invoice){
        return this.statusUpdatingSupplierInvoiceId === invoice.id
    },
    async changeSupplierInvoiceStatus(invoice, status){
        if (this.isSupplierInvoiceStatusDropdownDisabled(invoice) || invoice.status === status) return

        const toggle = document.getElementById(`supplier-invoice-status-${invoice.id}`)
        let statusDropdown = null
        if (toggle) {
            // eslint-disable-next-line no-undef
            statusDropdown = bootstrap.Dropdown.getInstance(toggle) || new bootstrap.Dropdown(toggle)
            statusDropdown.hide()
        }

        const previousStatus = invoice.status
        this.statusUpdatingSupplierInvoiceId = invoice.id
        this.$set(invoice, 'status', status)

        try{
            await helper.customPatch(
                `${process.env.VUE_APP_API}/supplier-invoices/${invoice.id}`,
                { status },
                { showToast: true }
            )
            if (statusDropdown) statusDropdown.hide()
        }catch(error){
            this.$set(invoice, 'status', previousStatus)
        }finally{
            await this.getInvoices(this.page)
            this.statusUpdatingSupplierInvoiceId = null
        }
    },
    async transferCreditNote(invoice){
 
        invoice.total = invoice.products && invoice.products.length ? invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;

        this.invoice = invoice
        this.createCreditInvoiceModalState = !this.createCreditInvoiceModalState

    },
    generatePDF() {
        const doc = new jsPDF();

        const data = []
        for(let i = 0 ; i < this.invoices.length ; i++){
            const invoice = this.invoices[i]
            
            data.push([
                invoice.reference,
                `${this.formatMoney(this.calculateItemPrice(invoice))}`,
                `${this.formatMoney(invoice.amount_paid)}`,
                this.$t(invoice.status),
                this.$t(invoice.payment_method),
                invoice.supplier && invoice.supplier.name ? invoice.supplier.name : '-',
                this.formatDate(invoice.date)
            ])
        }
        doc.text("Factures", 15, 10);
        autoTable(doc,
        {
            head: [["Id", "Total(ttc)", "Total donnée", "Status", "Mode de paiment","Commande", "Client","Date"]],
            body: data
        })
        doc.save('factures.pdf')
    },
    generateCsv(){
        const data = []
        for(let i = 0 ; i < this.orders.length ; i++){
            const order = this.orders[i]
            data.push({
                "Id" : order.id,
                "Total(ttc)" : `${this.formatMoney(this.calculateItemPrice(order))}` ,
                "Total Donnée" : `${this.formatMoney(order.amount_paid)}`,
                "Rest" : `${this.formatMoney(order.total - order.amount_paid)}`,
                "Status" : this.$t(order.status),
                "Mode de paiment" : this.$t(order.payment_method),
                "Client" : order.supplier && order.supplier.name ? order.supplier.name : '-',
                "Date" : this.formatDate(order.date)
            })
        }

        return data
    },
    createCreditInvoiceModal(data){
        this.createCreditInvoiceModalState = data
    },
    refresh(){
        this.getInvoices()
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.getInvoices()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    },
    // New Filter Methods
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            if (filter.key === 'total_amount') {
                 this.activeFilters.push({
                    key: filter.key,
                    operator: 'gt',
                    value: 0
                });
            } else {
                // Default select the first option
                const defaultVal = filter.options[0].value;
                this.activeFilters.push({ 
                    key: filter.key, 
                    value: defaultVal 
                });
            }
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        this.getInvoices();
    },
    clearAllFilters() {
        this.activeFilters = [];
         this.getInvoices();
    },
    async fetchPaymentMethods(){
        try {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/payment-methods?per_page=100`)
            if(response.data && response.data.data){
                 const methods = response.data.data.filter(m => m.is_active);
                 // Find the payment_method filter config
                const filterConfig = this.availableFilters.find(f => f.key === 'payment_method');
                if (filterConfig) {
                    filterConfig.options = methods.map(m => ({
                        value: m.name.toLowerCase(),
                        label: m.name
                    }));
                     // Add 'all' option if not present or desired? Usually InvoiceComponent doesn't have 'all' in dropdown if not selected, 
                     // but here we are selecting specific values. 'all' is default when no filter active.
                     filterConfig.options.unshift({ value: 'all', label: 'all' });
                }
            }
        } catch (error) {
            alert(error)
        }
    },
    changeSelectedItem(){
        this.isSelectedItem = this.invoices.find(item => item.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.invoices.forEach(item => item.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.invoices.filter(item => item.selected).map(item => item.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/supplier-invoices/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.invoices = helper.withoutDeletedRecords(this.invoices, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('supplier_invoices_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.activeFilters.some(af => af.key === f.key));
    },
    activeFilterCount() { // Keep if needed for compatibility/debugging, or remove
        return this.activeFilters.length;
    },
    isFiltered() {
      return this.activeFilters.length > 0 || (this.keyword && this.keyword.length > 0) || (this.dateRangeOption !== '');
    },
    business(){ return this.$store.getters.BUSINESS},
    helper(){ return helper },
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    selectedCount() {
      return this.invoices.filter(item => item.selected).length;
    },
    areAllSelected() {
      return this.invoices.length > 0 && this.invoices.every(item => item.selected);
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
